import {JacksonType} from "@sonner/jackson-service-v2";

@JacksonType("NotaDeducaoFilter")
export class NotaDeducaoFilter {

  mes: number;

  ano: number;
}
